module.exports = __webpack_public_path__ + "img/classroom_2.331f72a1.jpg";